<mat-card class="daxa-card profile-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">Présentation du profile</h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="user d-flex align-items-center">
            <div class="image">
                <img src="assets/images/profile.jpg" class="rounded-circle" alt="profile-image">
            </div>
            <div class="title">
                <span class="d-block fw-medium">{{ user?.name }}</span>
                <span class="d-block text-body">{{ user?.username }}</span>
            </div>
        </div>
        <span class="sub-title d-block fw-medium">Rôle</span>
        <p>{{ user?.roles }}</p>

        <h5>Contact</h5>
        <div class="socials-link">
            <a href="mailto:{{ user?.username }}" class="mail d-inline-block text-center position-relative rounded-circle">
                <i class="ri-mail-fill"></i>
            </a>
        </div>
    </mat-card-content>
</mat-card>
